import create from 'zustand'

export const useServiceWorkerStore = create(() => ({
  message: undefined,
  severity: undefined,
}))
